import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.jsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../../public/static/fonts/Sharp_Grotesk/SharpGrotesk-Medium25.ttf%22,%22weight%22:%22400%22,%22style%22:%22normal%22}],%22variable%22:%22--sharp-grotesk-25-font%22}],%22variableName%22:%22sharpGrotesk25Font%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'sharpGrotesk25Font', 'sharpGrotesk25Font Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
